<div class="container reservations-export-container">

  <div class="reservations-export-topbar">
    <div class="form-check reservations-export-master-check">
      <input
        id="reservations-export-select-all"
        class="form-check-input"
        type="checkbox"
        [checked]="allFieldsSelected"
        (change)="toggleAllFields($any($event.target).checked)">
      <label class="form-check-label" for="reservations-export-select-all">
        {{ 'reservationsExport.selectAllClearAll' | translate }}
      </label>
    </div>
  </div>

  <hr>

  <div class="reservations-export-fields-scroll">
    <div class="reservations-export-fields-grid">
      <div class="reservations-export-field" *ngFor="let field of fieldOptions">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            [id]="'reservations-export-field-' + field.key"
            [checked]="settings[field.key]"
            (change)="toggleField(field.key)">
          <label
            class="form-check-label"
            [for]="'reservations-export-field-' + field.key">
            {{ field.labelKey | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <hr>

  <div class="reservations-export-format-row">
    <div class="form-check">
      <input
        id="reservations-export-format-excel"
        class="form-check-input"
        type="radio"
        name="reservationsExportFormat"
        [checked]="exportFormat === 'excel'"
        (change)="exportFormat = 'excel'">
      <label class="form-check-label"
        for="reservations-export-format-excel">
        {{ 'reservationsExport.excel' | translate }}
      </label>
    </div>

    <div class="form-check">
      <input
        id="reservations-export-format-csv"
        class="form-check-input"
        type="radio"
        name="reservationsExportFormat"
        [checked]="exportFormat === 'csv'"
        (change)="exportFormat = 'csv'">
      <label class="form-check-label" for="reservations-export-format-csv">
        {{ 'reservationsExport.csv' | translate }}
      </label>
    </div>
  </div>

  <hr *ngIf="exportFormat === 'csv'">

  <div class="reservations-export-delimiter-row" *ngIf="exportFormat === 'csv'">
  <label class="reservations-export-delimiter-label">
    {{ 'reservationsExport.delimiter' | translate }}
  </label>

  <app-dropdown
    [(model)]="settings.delimiter"
    [items]="delimiterOptions"
    [displayProperty]="'display'"
    [valueProperty]="'value'">
  </app-dropdown>
</div>

  <hr>

  <div *ngIf="message" class="alert alert-danger mb-3">
    {{ message | translate }}
  </div>

  <div class="reservations-export-footer">
    <button class="btn btn-sec flex-fill" (click)="cancel()">
      {{ 'common.buttons.cancel' | translate }}
    </button>
    <button class="btn btn-main flex-fill" (click)="export()">
      {{ 'common.buttons.set' | translate }}
    </button>
  </div>
</div>